import React from 'react';
import Select from 'react-select';

type OptionsType = {
  value: any;
  label: any;
}

type AppProps = {
  placeholder?: string;
  options: OptionsType[] | [];
  extraClasses?: string;
  handleChange?: (value: any) => void;
  value: OptionsType | null;
  isClearable?: boolean;
  disabled?: boolean;
  style?: any;
  components?:any;
}

const DropDown = ({
  placeholder,
  options,
  extraClasses,
  handleChange,
  value,
  disabled,
  isClearable,
  style,
  components
}: AppProps) => {
  return (
    <>
      <Select
        classNamePrefix="react-select"
        inputProps={{ autoComplete: 'nope' }}
        placeholder={placeholder}
        options={options}
        className={`${ extraClasses ?? '' } react-select`}
        value={value}
        onChange={handleChange}
        isClearable={isClearable}
        isDisabled={disabled}
        styles={style}
        components={components}
      />
    </>
  )
};

export default DropDown;